import React, { useState, useEffect } from 'react';
import commonMethod from '../../lib/commonMethod'
import CloseIcon from '../../assets/img/dashboard/iconClose';
import cookie from 'react-cookies';
// import _ from 'lodash';
import EditInform from '../../assets/img/dashboard/editInform';
import RoomList from './room_panel/RoomList'

const RoomSetting = ({ closePanel, roomList, panelRoomToggle, roomChange }) => {
  const accessToken = cookie.load('accessToken');
  const familyId = cookie.load('familyId');
  const [roomName, setRoomName] = useState("");
  const [viewTooltip, setTooltip] = useState(false);
  const [lists, setList] = useState([]);
  const [requests, setRequest] = useState([]);
  const [refreshs, setRefresh] = useState(false);

  useEffect(() => {
    if (panelRoomToggle === false) {
      lists.length = 0;
      requests.length = 0;
    } else {
      (roomList && roomList.length > 0) && roomList.forEach(v => {
        setList(lists => lists.concat(v));
      })
    }
  }, [panelRoomToggle])

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (roomName && roomName.length > 0) {
        addRoom();
      }
    }
  }

  const addRoom = () => {
    let tempId = Date.now();
    if (roomName.length === 0) return;
    if (lists.length < 50) {
      setList(lists => lists.concat({
        name: roomName,
        room_id: tempId,
      }));
      setRequest(requests => requests.concat({
        method: "add",
        name: roomName,
        room_id: tempId,
      }));
      setRoomName("");
      setTimeout(function () {
        document.getElementsByClassName("room-display")[0].scrollTop = document.getElementsByClassName("room-display")[0].scrollHeight;
      }, 1)
    } else {
      setTooltip(true);
      setTimeout(function () {
        setTooltip(false);
      }, 1000);
    }
  }

  const editList = (id, name) => {
    let addEdit = true;
    if (requests.length !== 0) {
      requests.forEach(element => {
        if (element.method === "add" && element.room_id === id) {
          element.name = name;
          addEdit = false;
        }
        if (element.method === "edit" && element.room_id === id) {
          element.name = name;
          addEdit = false;
        }
        roomList.forEach(v => {
          if (v.room_id === element.room_id && v.name === name) {
            addEdit = false;
            setRequest(requests.filter(element => (element.name !== v.name)))
          }
        })
      })
      if (addEdit === true) {
        setTimeout(function () {
          setRequest(requests => requests.concat({
            method: "edit",
            name: name,
            room_id: id,
          }))
        });
      }
    } else {
      setTimeout(function () {
        setRequest(requests => requests.concat({
          method: "edit",
          name: name,
          room_id: id,
        }))
      });
    }
  }

  const delList = (id, name, isDel) => {
    let addDel = true;
    if (requests.length !== 0) {
      requests.forEach(element => {
        if (element.method === "del") {
          if (element.name === name && element.room_id === id) {
            element.del = !element.del;
            addDel = false;
          }
        }
      })
      if (addDel === true) {
        setRequest(requests => requests.concat({
          method: "del",
          name: name,
          room_id: id,
          del: !isDel,
        }));
      }
    } else {
      setRequest(requests => requests.concat({
        method: "del",
        name: name,
        room_id: id,
        del: !isDel,
      }));
    }
  }

  const cancel = () => {
    lists.length = 0;

    setTimeout(function () {
      if(roomList && roomList.length > 0) {
        roomList.forEach(v => {
          setList(lists => lists.concat(v));
        })
      } else {
        setList([]);
      }
    })
    requests.length = 0;
  }

  const submit = () => {
    let compare = [...requests];
    let delList = [];
    compare = compare.filter(element => element.del !== false);

    compare.forEach(v => {
      if (v.method === "del" && v.del === true) {
        delList = delList.concat(v);
        compare.forEach(f => {
          if (f.room_id === v.room_id) {
            compare = compare.filter(element => element.room_id !== v.room_id);
          }
        })
      }
    })
    compare = compare.concat(delList);

    let isAdd = compare.filter(element => JSON.stringify(element.room_id).length > 9).filter(element => element.method !== "del");
    compare = compare.filter(element => JSON.stringify(element.room_id).length < 9);
    compare = compare.concat(isAdd);

    setTimeout(function () {
      compare.forEach(v => {
        let data = { "name": v.name }
        if (v.method === "add") {
          commonMethod.requestPostWithData('dashboard/homes/' + familyId + '/room', accessToken, JSON.stringify(data), this, res => { });
        } else if (v.method === "edit") {
          commonMethod.requestPutWithData('dashboard/homes/' + familyId + '/rooms/' + v.room_id, accessToken, JSON.stringify(data), this, res => { });
        } else if (v.method === "del") {
          commonMethod.requestDelWithToken('dashboard/homes/' + familyId + '/rooms/' + v.room_id, accessToken, this, res => { });
        }
      })
    })
    setTimeout(function () {
      setRefresh(true);
      requests.length = 0;
      setTimeout(function () {
        roomChange(refreshs);
      }, 10)
    }, 100)
  }

  return (
      <div className="room-setting">
        <React.Fragment>
          <section className="room-setting-header">
            <p className="close-panel" onClick={closePanel}><CloseIcon /></p>
            <h3>방 편집</h3>
          </section>
          <div className="room-scroll">
            <section className="room-setting-body">
              <div className="addRoom">
                <span>방 추가</span>
                <label
                    htmlFor="add-room"
                    onMouseOver={() => setTooltip(true)}
                    onMouseLeave={() => setTooltip(false)}
                >
                  <EditInform />
                </label>
                <p className={viewTooltip ? "auto-tooltip active" : "auto-tooltip"}>
                  방은 최대 50개까지 추가할 수 있습니다.
                </p>
                <input
                    type="text"
                    onChange={(e) => setRoomName(e.target.value)}
                    value={roomName}
                    onKeyPress={(e) => handleKeyPress(e)}
                />
                <button
                    className={roomName.length > 0 && lists.length < 50 && "addButton"}
                    disabled={roomName < 1 && lists.length > 49}
                    onClick={() => addRoom()}
                >
                  추가
                </button>
              </div>
              {
                lists.length > 0 && (
                    <>
                      <div className="roomList">
                        <span>내 방 목록</span>
                      </div>
                      <div className="room-display">
                        <ul>
                          {(lists && lists.length > 0) && lists.map(v => {
                            return (
                                <li key={v.room_id} id={v.room_id} >
                                  <RoomList
                                      name={v.name}
                                      id={v.room_id}
                                      editList={editList}
                                      delList={delList}
                                  />
                                </li>
                            )
                          })}
                        </ul>
                      </div>
                    </>
                )
              }
            </section>
            <section className="room-setting-footer">
              <button
                  className={requests.length !== 0 && "active"}
                  onClick={() => { requests.length !== 0 && cancel() }}
              >
                취소
              </button>
              <button
                  className={requests.length !== 0 && "active"}
                  onClick={() => { requests.length !== 0 && submit() }}
              >
                저장
              </button>
            </section>
          </div>
        </React.Fragment>
      </div>
  );
}

export default RoomSetting;
